<template>
  <transition
    name="fade"
    class="d-block modal"
  >
    <div class="d-block modal modal-backdrop">
      <div class="modal-dialog">
        <div class="modal-content pt-5 pb-4 px-4">
          <button
            type="button"
            class="modal-base__close btn-oval btn-oval--transparent"
            @click="$emit('close-modal')"
          >
            <span class="icon-close-big" />
          </button>
          <slot name="header">
            <div class="px-3">
              <h5 class="modal-title mb-4">
                {{ I18n.t("employees.auctions_catalogs.modal.delete_order_header") }}
              </h5>
              <p v-html="contentText" />
            </div>
          </slot>
          <div class="modal-buttons d-flex justify-content-center mt-2">
            <slot name="approveBtn" />
            <slot name="disapproveBtn" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  /* global I18n */
  import { formatNumber } from '@/shared/helpers';
  import { MODAL_OPEN_CLASS } from '@/employees_orders_panel/consts';

  export default {
    name: 'Modal',
    props: { bid: { type: Object, required: true } },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    computed: {
      bidValue() {
        return this.bid.value ? this.bid.value : this.bid.limit;
      },
      contentText() {
        return I18n.t('employees.auctions_catalogs.modal.delete_order_content_html', {
          user: this.bid.user.fullname,
          value: this.formatPrice(this.bidValue),
        });
      },
    },
    mounted() {
      document.body.className = MODAL_OPEN_CLASS;
    },
    destroyed() {
      document.body.className = '';
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/modal.vue?fbd227ba